import React, { Fragment, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from '../../actions/auth';

const Login = ({ login, isAuthenticated }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const { email, password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    login(email, password);
  };

  if (isAuthenticated) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Fragment>
      {/* <div className="row justify-content-center">
        <div className="col-9 col-md-8 col-lg-6 my-5">
          <h1 className="rb">Sign In</h1>
          <h5 className="rb pt-3">Login To Your Account</h5>
          <form className="my-3" onSubmit={e => onSubmit(e)}>
            <div className="form-row pb-3">
              <div className="form-group col-12">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={email}
                  onChange={e => onChange(e)}
                  required
                />
              </div>
              <div className="form-group col-12">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={e => onChange(e)}
                  minLength="6"
                  required
                />
              </div>
            </div>

            <input
              type="submit"
              className="btn btn-primary btn-block rb"
              value="Login"
            />
          </form>
          <p className="my-4">
            Don't have an account? <Link to="/register">Sign Up</Link>
          </p>
        </div>
      </div> */}

      <div className="auth-section">
        <h4 className="form-header">Sign In</h4>
        <form className="account-form" onSubmit={(e) => onSubmit(e)}>
          <div className="form-row">
            <div className="form-group col-12">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={email}
                onChange={(e) => onChange(e)}
                placeholder="JaneDoe@gmail.com"
                required
              />
            </div>
            <div className="form-group col-12">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                value={password}
                onChange={(e) => onChange(e)}
                required
              />
            </div>
          </div>
          <input
            type="submit"
            className="btn primary-btn auth-btn"
            value="Login"
          />
        </form>
        <p className="change-form-text">
          Don't have an account? <Link to="/register">Sign Up</Link>
        </p>
      </div>
    </Fragment>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { login })(Login);
